export default "__VITE_ASSET__D2TsoP0y__"